<template>
  <module-box
    type="material-info"
    :mode="mode"
    :moduleData="moduleData"
    @onDelete="handleDeleteModule"
    @onMore="handleMore"
  >
    <div class="material-info">
      <module-title :mode="mode" :title="moduleData.title" @onChange="handleTitleChange"></module-title>
      <draggable
        class="info-list"
        v-model="dragList"
        :animation="200"
        :group="'materialInfoList'"
        :disabled="mode !== 'edit'"
        :ghostClass="'ghost'"
        :handle="'.edit-drag'"
        @start="drag = true"
        @end="drag = false"
        @change="handleSortDragList"
      >
        <template v-if="moduleData.list && moduleData.list.length > 0">
          <div class="list-item" v-for="(data, index) in dragList" :key="data.key">
            <info-item
              :mode="mode"
              :data="data"
              @onAdd="handleAddListInfo(index)"
              @onDelete="handleListItemDelete(index)"
              @onChange="data => handleListItemChange(index, data)"
            ></info-item>
          </div>
        </template>
        <template v-else-if="mode === 'edit'">
          <button class="add-btn" @click.stop="handleAddListInfo">
            <i class="icon wiki-editable-add"></i>
          </button>
        </template>
      </draggable>
    </div>
  </module-box>
</template>

<script>
import draggable from "vuedraggable";
// components
import ModuleBox from "../../components/ModuleBox";
import TextBox from "../../components/TextBox";
import ModuleTitle from "../../components/ModuleTitle";
import InfoItem from "./components/InfoItem";
export default {
  name: "MaterialInfo",
  components: {
    draggable,
    ModuleBox,
    TextBox,
    ModuleTitle,
    ModuleTitle,
    InfoItem
  },
  props: {
    mode: String,
    moduleData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      drag: false,
      dragList: []
    };
  },
  watch: {
    moduleData: {
      handler(val) {
        this.dragList = val.list;
      },
      immediate: true
    }
  },

  mounted() {},

  methods: {
    // 模块更多操作
    handleMore(command, data) {
      if (command === "copy") {
        const moduleData = JSON.parse(JSON.stringify(this.moduleData));
        this.$emit("onCopy", moduleData);
      }
    },
    // 模块删除
    handleDeleteModule() {
      this.$emit("onDelete");
    },
    handleTitleChange(title) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.title = title;
      this.$emit("onChange", moduleData);
    },
    handleSortDragList() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.list = this.dragList;
      this.$emit("onChange", moduleData);
    },
    handleAddListInfo(index = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.list.push({
        key: Math.random().toString(16),
        title: "",
        content: []
      });
      this.$emit("onChange", moduleData);
    },
    handleListItemDelete(index = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.list.splice(index, 1);
      this.$emit("onChange", moduleData);
    },
    handleListItemChange(index, data) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.list.splice(index, 1, data);
      this.$emit("onChange", moduleData);
    }
  }
};
</script>

<style lang="less" scoped>
.material-info {
  .info-list {
    padding: 24px;
  }
}

.add-btn {
  width: 20px;
  height: 20px;
  color: #ffffff;
  border-radius: 4px;
  margin-left: 3px;
  border: none;
  vertical-align: middle;
  line-height: 20px;
  text-align: center;
  &:hover {
    opacity: 0.9;
  }
  .icon {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
</style>
